"use strict";

var _taggedTemplateLiteral = require("/codebuild/output/src253626114/src/mrt-covid19-center/node_modules/@babel/runtime/helpers/taggedTemplateLiteral");

var _templateObject, _templateObject2, _templateObject3, _templateObject4, _templateObject5, _templateObject6, _templateObject7, _templateObject8;

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.wrapper = void 0;

var react_1 = require("@emotion/react");

var sizeStyles = {
  small: react_1.css(_templateObject || (_templateObject = _taggedTemplateLiteral(["\n    padding: 3px 6px;\n    font-size: 12px;\n    letter-spacing: -0.4px;\n  "]))),
  medium: react_1.css(_templateObject2 || (_templateObject2 = _taggedTemplateLiteral(["\n    padding: 5px 8px;\n    font-size: 13px;\n    letter-spacing: -0.35px;\n  "])))
};
var colorStyles = {
  yellow: react_1.css(_templateObject3 || (_templateObject3 = _taggedTemplateLiteral(["\n    color: var(--yellow-700);\n    background-color: var(--yellow-80);\n  "]))),
  green: react_1.css(_templateObject4 || (_templateObject4 = _taggedTemplateLiteral(["\n    color: var(--green-700);\n    background-color: var(--green-50);\n  "]))),
  gray: react_1.css(_templateObject5 || (_templateObject5 = _taggedTemplateLiteral(["\n    color: var(--gray-700);\n    background-color: var(--gray-60);\n    box-shadow: 0 0 0 1px var(--gray-80) inset;\n  "]))),
  blue: react_1.css(_templateObject6 || (_templateObject6 = _taggedTemplateLiteral(["\n    color: white;\n    background-color: var(--blue-400);\n    font-weight: 600;\n  "]))),
  black: react_1.css(_templateObject7 || (_templateObject7 = _taggedTemplateLiteral(["\n    color: white;\n    background-color: var(--gray-900);\n    font-weight: bold;\n  "])))
};

var wrapper = function wrapper(size, color) {
  return react_1.css(_templateObject8 || (_templateObject8 = _taggedTemplateLiteral(["\n  display: inline-flex;\n  border-radius: 4px;\n  font-weight: bold;\n  ", ";\n  ", ";\n\n  & > img {\n    margin-right: 2px;\n  }\n"])), sizeStyles[size], colorStyles[color]);
};

exports.wrapper = wrapper;